import ImageBox, { ImageBoxProps } from 'components/common/ImageBox'
import { ComponentProps, FC } from 'react'

const MarkdownImage: FC<Partial<ImageBoxProps & ComponentProps<'img'>>> = ({ src, alt, ...props }) => {
  if (!src || !alt) return null

  // A block <span>, not a <div>: Markdown images sit inside a <p> (server-rendered Datafolha pages).
  return (
    <ImageBox
      {...{ src, alt }}
      {...props}
      as="span"
      display="block"
      width="100%"
      height={400}
      _hover={{ transform: 'scale(1.02)' }}
      transition="transform 250ms ease-out"
      cursor="pointer"
      imgObjectFit="contain"
    />
  )
}

export default MarkdownImage
